module.exports = __webpack_public_path__ + "img/6-3.dacb1a55.png";